import { gql } from "@apollo/client";

const CREATE_SCHEDULE = gql`
  mutation CreateSchedule($args: CreateScheduleInput!) {
    createSchedule(args: $args) {
      _id
    }
  }
`;

const CANCEL_SCHEDULE = gql`
  mutation CancelSchedule($scheduleId: ID!) {
    cancelSchedule(scheduleId: $scheduleId) {
      _id
    }
  }
`;

const UPDATE_SCHEDULE = gql`
  mutation UpdateSchedule($args: UpdateScheduleInput!, $scheduleId: ID!) {
    updateSchedule(args: $args, scheduleId: $scheduleId) {
      _id
      status
    }
  }
`;

export { CREATE_SCHEDULE, CANCEL_SCHEDULE, UPDATE_SCHEDULE };
